export default "__VITE_ASSET__D6Wd$_TS__"